import { render, staticRenderFns } from "./treatment-detail-order.html?vue&type=template&id=9c2a2ae2&scoped=true&"
import script from "./treatment-detail-order.js?vue&type=script&lang=js&"
export * from "./treatment-detail-order.js?vue&type=script&lang=js&"
import style0 from "./treatment-detail-order.scss?vue&type=style&index=0&id=9c2a2ae2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c2a2ae2",
  null
  
)

export default component.exports